module.exports = __webpack_public_path__ + "img/question-image.d426171f.png";